import { get, post, destroy } from "./base";

const upsertRule = async (payload) => {
    return await post('/return-rules/upsert', payload);
};

const getAllRules = async () => {
    return await get('/return-rules');
};

const deleteRule = async (id) => {
    return await destroy(`/return-rules/${id}`);
};

const ReturnRuleServ = {
    upsertRule,
    getAllRules,
    deleteRule
};

export default ReturnRuleServ;
